export const MODIFY_FILES_FETCHED_TIME = 'MODIFY_FILES_FETCHED_TIME';

export function modifyFilesFetchedTime(){
    return{
        type: MODIFY_FILES_FETCHED_TIME,
        mainState: {
            filesFetchedTime: new Date()
        }
    }
}